module.exports = __webpack_public_path__ + "img/van-simple.24afd62a.svg";